import { defineModule } from '@/app/router/defineModule.ts';

export default defineModule({
    name: 'activities',
    routes: [],
});
